<template>
  <NavigationButtonBack :url="url" :label="label" />
</template>
<script setup lang="ts">
interface Props {
  links: Links;
}

const props = defineProps({
  links: null
});

const route = useRoute();

const profile = useProfileStore();

const { mainContent } = useContents();

const label = computed(() => {
  if (!props.links.length) return 'Retour';
  return props.links.length >= 2
    ? `${props.links[0].label} - ${props.links[1].label}`
    : `${props.links[0].label}`;
});

const baseUrl = computed(() => {
  const parts = route.path.split('/');
  return parts.length > 2 ? `/${parts[1]}` : '/';
});

const url = computed(() => {
  const currentPath = route.path;
  const backLinks = [...props.links].reverse();
  const backLink = backLinks.find((link, index) => {
    return !link.url.includes(currentPath);
  });
  const url = backLink?.url || baseUrl.value;

  if (mainContent?.value?.path && url === mainContent.value.path) {
    return profile.isParent
      ? `/${Sections.ParentForYou}`
      : `/${Sections.Revisions}`;
  } else {
    return url;
  }
});
</script>
